module.exports = __webpack_public_path__ + "ef2c0645e5b57898a7de59143a55ffca.svg";